// extracted by mini-css-extract-plugin
export default {"root":"NPf0eM"};